import ApplicationController from "./application_controller";

export default class extends ApplicationController {

  static targets = [ 'startTime', 'endTime', 'location' ]

  updateEndTime() {
    // add 30 minutes to the start time
    const startTime = this.startTimeTarget.value;
    const endTime = new Date(startTime);
    endTime.setMinutes(endTime.getMinutes() + 60);
    this.endTimeTarget._flatpickr.setDate(endTime);
  }

  updateLocationType() {
    const selected = this.element.querySelector('input[name="meeting[location_type]"]:checked')
    const location = selected ? selected.value : ''
    this._refreshLocationTypeStyles()
    // Synchron zu Meeting::LOCATION_TYPES_USING_LINK
    if (['msteams', 'zoom', 'jitsi', 'online'].includes(location)) {
      this.locationTarget.value = ''
    }
  }

  // Tailwind 2 (postcss7-compat) generiert keine peer-checked:-Varianten —
  // daher hier explizit die Aktiv-Klassen am sichtbaren <span> umsetzen.
  _refreshLocationTypeStyles() {
    const ACTIVE = ['bg-gray-200', 'text-gray-900', 'z-10']
    const INACTIVE = ['bg-white', 'text-gray-700', 'hover:bg-gray-50']
    this.element.querySelectorAll('input[name="meeting[location_type]"]').forEach(radio => {
      const span = radio.nextElementSibling
      if (!span) return
      if (radio.checked) {
        span.classList.remove(...INACTIVE)
        span.classList.add(...ACTIVE)
      } else {
        span.classList.remove(...ACTIVE)
        span.classList.add(...INACTIVE)
      }
    })
  }

  setToday(event) {
    event.preventDefault();
    const today = new Date();
    today.setHours(today.getHours() + 1);
    this.startTimeTarget._flatpickr.setDate(today);
    this.updateEndTime();
  }

  setTomorrow(event) {
    event.preventDefault();
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    this.startTimeTarget._flatpickr.setDate(tomorrow);
    this.updateEndTime();
  }

  setNextWeek(event) {
    event.preventDefault();
    const nextWeek = new Date();
    nextWeek.setDate(nextWeek.getDate() + 7);
    this.startTimeTarget._flatpickr.setDate(nextWeek);
    this.updateEndTime();
  }

  setNextMonth(event) {
    event.preventDefault();
    const nextMonth = new Date();
    nextMonth.setMonth(nextMonth.getMonth() + 1);
    this.startTimeTarget._flatpickr.setDate(nextMonth);
    this.updateEndTime();
  }

}
